
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["lds-rolling",classNames,staticClass],
              style: [{"background":"0 0"},style,staticStyle],
              attrs: Object.assign({"width":"200","height":"200","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","style":"background:0 0"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"50","cy":"50","fill":"none","stroke":"#0C3C60","stroke-width":"4","r":"35","stroke-dasharray":"164.93361431346415 56.97787143782138","transform":"rotate(96.936 50 50)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","calcMode":"linear","values":"0 50 50;360 50 50","keyTimes":"0;1","dur":"1.3s","begin":"0s","repeatCount":"indefinite"}})])])
          )
        }
      }
    